import type { StatsPeriod } from '$entities/stats';

export const PERIOD_OPTIONS: { value: StatsPeriod; label: string }[] = [
	{ value: '24h', label: '24 Hours' },
	{ value: '7d', label: '7 Days' },
	{ value: '30d', label: '30 Days' },
	{ value: 'all', label: 'All Time' },
	{ value: 'custom', label: 'Custom' }
];

export function formatCurrency(value: number): string {
	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	}).format(value);
}

export function formatNumber(value: number): string {
	return new Intl.NumberFormat('en-US').format(value);
}

export function formatDateRange(startDate: string, endDate: string): string {
	if (!startDate || !endDate) return '';
	const start = new Date(startDate);
	const end = new Date(endDate);
	return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
}

export function formatChartLabel(dateEpoch: number, period: StatsPeriod): string {
	const date = new Date(dateEpoch * 1000);
	if (period === '24h' || period === '7d' || period === 'custom') {
		return date.toLocaleDateString('en-US', {
			month: 'short',
			day: 'numeric',
			hour: 'numeric'
		});
	} else {
		return date.toLocaleDateString('en-US', {
			month: 'short',
			day: 'numeric',
			year: period === 'all' ? '2-digit' : undefined
		});
	}
}
